export default __webpack_public_path__ + "756362f7339c0376f4f74b0c8c1ee32c.png";